import state from "./state";

export function getAccount() {
  return state.account;
}
export function getUserDetails() {
  return state.user;
}